import { render, staticRenderFns } from "./scale-submitted-preview.vue?vue&type=template&id=4f37c4d8&scoped=true&"
import script from "./scale-submitted-preview.vue?vue&type=script&lang=js&"
export * from "./scale-submitted-preview.vue?vue&type=script&lang=js&"
import style0 from "./scale-submitted-preview.vue?vue&type=style&index=0&id=4f37c4d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f37c4d8",
  null
  
)

component.options.__file = "scale-submitted-preview.vue"
export default component.exports